// extracted by mini-css-extract-plugin
export default {"emptyTable":"FbTYnSRJKSDV7dfEXgif"};